export default "__VITE_ASSET__0oSdDoL1__"